module.exports = __webpack_public_path__ + "img/sv74on.3abce666.svg";